// extracted by mini-css-extract-plugin
export default {"alertContainer":"GKRD5FJ7cTY0IjZUxsQl"};